import { useState, useEffect } from "react";
import { BRANCHES, MACHINES } from "../data/constants";
import { formatDate } from "../utils/date";
import { useWindowSize } from "../hooks/useWindowSize";
import RangeCalendar from "./RangeCalendar";
import { useNavigate, useParams } from "react-router-dom";
import BranchMachineAssign from "./BranchMachineAssign";
import { MachinesFetchAPI } from "../../../api/Machines";
import { getRandomColor } from "../../utils/RandomColor";
import { EventsFetchAPI } from "../../../api/Events";
import AlertSmall from "../../Alerts/AlertSmall";
import { RenderIf } from '../../utils/RenderIf';

export default function EventDetail({ event, onClose, onSave, onDelete, getEventDetaills, getEvents, branchOfficesData, setBranchOfficesData, setSelectedEvent }) {
  // Función para formatear fecha a 'YYYY-MM-DD HH:mm:ss', si es end termina en 23:59:59
  const navigate = useNavigate();
  const formatDateTime = (date, isEnd = false) => {
    if (!date) return '';
    const d = typeof date === 'string' ? new Date(date) : date;
    const pad = (n) => n.toString().padStart(2, '0');
    if (isEnd) {
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} 23:59:59`;
    }
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
  };



  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState({ ...event, branchMachines: { ...(event.branchMachines || {}) } });

  const [databranchesMachines, setDataBranchesMachines] = useState([]);
  const [hovered, setHovered] = useState(null);
  const [pm, setPm] = useState(event.start.getMonth());
  const [py, setPy] = useState(event.start.getFullYear());
  const { w } = useWindowSize();
  const compact = w < 640;
  const [newBranches, setNewBranches] = useState([]);
  // Estados para acordeón
  const [openBranch, setOpenBranch] = useState(null);
  const [openMachineAccordion, setOpenMachineAccordion] = useState(null);
  const [machinesByBranch, setMachinesByBranch] = useState({});
  const [machinesAllByBranch, setMachinesAllByBranch] = useState({});
  const [eventHandle, setEventHandle] = useState(0);
  const handleSave = () => { onSave(form); setEditing(false); };
  const [nameEdit, setNameEdit] = useState(event.name);
  const [descriptionEdit, setDescriptionEdit] = useState(event.description);
  const [typeEdit, setTypeEdit] = useState("event");
  const [newDate, setNewDate] = useState({ start: event.start, end: event.end });



  // Function to get all machines from all selected branches and consolidate into a single array
  const getMachines = async () => {
    let token = localStorage.getItem('x-access-token');
    let allMachines = [];
    const requests = form.branches.map(async (branchoffice_id) => {
      try {
        const machines = await MachinesFetchAPI.getMachinesByBranchOffice(branchoffice_id, token);
        const formatdatamachine = machines.data.data.map((m) => ({
          id: m.machine_per_branch_id,
          name: m.machine_name,
          color: getRandomColor(),
        }));
        allMachines = allMachines.concat(formatdatamachine);
      } catch (err) {
        console.log(err);
      }
    });

    await Promise.all(requests);
    setDataBranchesMachines(allMachines); // Store the consolidated array in state
    return allMachines;
  }

  const deleteBarnchFromEvent = async (branch) => {
    // Remover sucursal del evento
    let token = localStorage.getItem('x-access-token');
    try {
      await EventsFetchAPI.deleteBranchofficeFromEvent({ "event_id": event.id, "branchoffices": [branch] }, token);
      // Actualizar el detalle
      const detail = await getEventDetaills(event, true);

      console.log(detail);
      setSelectedEvent(detail);
      setForm(prev => ({
        ...detail,
        branches: (detail.branches || []).filter(bId => bId !== branch),
        branchMachines: { ...(detail.branchMachines || {}) }
      }));
      setOpenBranch(null);
    } catch (err) {
      AlertSmall({ message: 'Error al remover sucursal', icon: 'error' });
    }
  }

  const updateEvent = async (state) => {
    let token = localStorage.getItem('x-access-token');
    try {
      // Construir el objeto de datos con todos los campos editables
      let data = {
        name: nameEdit,
        description: descriptionEdit,
        // Puedes agregar aquí otros campos que deban actualizarse
      };

      console.log(state);
      if (state !== undefined) {
        data.state = state;
      }
      const response = await EventsFetchAPI.updateEvent(event.id, data, token);
      await getEvents();
      const detail = await getEventDetaills(event, true);
      getEvents();
      setSelectedEvent(detail);


      if (state) {
        setForm({ ...detail, state: state });
      } else {
        setForm({ ...detail, name: nameEdit, description: descriptionEdit });
      }
      setEditing(false);
    } catch (err) {
      console.log(err);
    }
  }

  const updateDateEvent = async () => {
    try {
      let token = localStorage.getItem('x-access-token');
      let data = {
        initialDate: formatDateTime(newDate.start),
        maxDate: formatDateTime(newDate.end, true),
      };
      console.log(data);
      const response = await EventsFetchAPI.updateDateEvent(event.date_id, data, token);
      getEvents();
      setForm(prev => ({ ...prev, start: newDate.start, end: newDate.end }));
      AlertSmall({ message: 'Fechas del evento actualizadas correctamente', icon: 'success' });
      setEditing(false);
      setTypeEdit("event");
      setEventHandle(1);
    } catch (err) {
      AlertSmall({ message: 'Error al actualizar fechas del evento', icon: 'error' });
      // Manejo de error
    }
  }



  const asignBranchToEvent = async () => {
    let startTime = Date.now();
    try {
      let token = localStorage.getItem('x-access-token');
      let data = {
        "event_id": event.id,
        "branchoffices": newBranches // Asignar solo la última sucursal agregada
      }
      const res = await EventsFetchAPI.assignBranchofficestoEvent(data, token);
      AlertSmall({ message: 'Sucursal asignada al evento correctamente', icon: 'success' });
      getEvents(event);
      const detail = await getEventDetaills(event, true);
      setSelectedEvent(detail);
      setForm({ ...detail, branchMachines: { ...(detail.branchMachines || {}) } });
      setNewBranches([]);
    } catch (err) {
      AlertSmall({ message: 'Error al asignar sucursal al evento', icon: 'error' });
    }
  }

  useEffect(() => {
    console.log("Evento seleccionado:", event);
    if (event) {
      getMachines();
    }
  }, [event]);

  useEffect(() => {
    setEventHandle(0);
  }, [eventHandle]);

  if (!editing) {
    return (
      <div>
        <div className="ec-detail-header">
          <div className="ec-detail-header-info">
            <h2 className="ec-detail-title">Evento: </h2>

            <div
              className="ec-detail-branch-name"
              style={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                padding: '12px 16px',
                fontWeight: 600,
                fontSize: 16,
                color: '#1a1a2e',
                borderBottom: '1px solid #e5e7eb',
                background: '#f3f4f6',
                borderRadius: '12px',
              }}
              onClick={() => (setEditing(true), setTypeEdit("event"))}
            >
              <span style={{ flex: 1 }}><i class="uil uil-edit-alt text-center"> </i>  - {form.name}</span>
              <span
                style={{
                  marginLeft: 8,
                  fontSize: 20,
                  display: 'flex',
                  alignItems: 'center',
                  transition: 'color 0.2s',
                  color: '#b0b8c4',
                }}
              >

              </span>
            </div>

            <div
              className="ec-detail-branch-name"
              style={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                padding: '12px 16px',
                fontWeight: 600,
                fontSize: 16,
                color: '#1a1a2e',
                borderBottom: '1px solid #e5e7eb',
                background: '#f3f4f6',
                borderRadius: '12px',
              }}
              onClick={() => (setEditing(true), setTypeEdit("date"))}
            >
              <span style={{ flex: 1 }}><i class="uil uil-edit-alt text-center"> </i>  - {formatDate(form.start)} → {formatDate(form.end)}</span>
              <span
                style={{
                  marginLeft: 8,
                  fontSize: 20,
                  display: 'flex',
                  alignItems: 'center',
                  transition: 'color 0.2s',
                  color: '#b0b8c4',
                }}
              >

              </span>
            </div>

            <div
              className="ec-detail-branch-name"
              style={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                padding: '12px 16px',
                fontWeight: 600,
                fontSize: 16,
                color: '#1a1a2e',
                borderBottom: '1px solid #e5e7eb',
                background: '#f3f4f6',
                borderRadius: '12px',
              }}
            >
              <span style={{ flex: 1 }}>Codigo: {form.code}</span>
              <span
                style={{
                  marginLeft: 8,
                  fontSize: 20,
                  display: 'flex',
                  alignItems: 'center',
                  transition: 'color 0.2s',
                  color: '#b0b8c4',
                }}
              >

              </span>
            </div>


            <div
              className="ec-detail-branch-name"
              style={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                padding: '12px 16px',
                fontWeight: 600,
                fontSize: 16,
                color: '#1a1a2e',
                borderBottom: '1px solid #e5e7eb',
                background: '#f3f4f6',
                borderRadius: '12px',
              }}
               onClick={() => (setEditing(true), setTypeEdit("branch"))}
            >

              {/* Mostrar máquinas ecommerce asignadas al evento */}
              <div className="ec-form-group">
                <label className="ec-label">Máquina Ecommerce asignada</label>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                  {Object.entries(form.branchMachines || {}).map(([bId, machineIds]) => {
                    const branch = branchOfficesData.find(b => b.id === bId);
                    if (!branch) return null;
                    return machineIds
                      .map(mId => {
                        const m = branch.machines && branch.machines.find(x => x.id === mId || x.machine_per_branch_id === mId);
                        if (m && (m.type === "Smartpay Ecommerce" || m.name === "Smartpay Ecommerce")) {
                          return (
                            <span key={mId} style={{ background: branch.color + '14', color: branch.color, borderRadius: 8, padding: '6px 14px', fontWeight: 500 }}>
                              {branch.name} - {m.name}
                            </span>
                          );
                        }
                        return null;
                      })
                      .filter(Boolean);
                  })}
                  {/* Si no hay ninguna */}
                  {Object.entries(form.branchMachines || {}).every(([bId, machineIds]) => {
                    const branch = branchOfficesData.find(b => b.id === bId);
                    if (!branch) return true;
                    return machineIds.every(mId => {
                      const m = branch.machines && branch.machines.find(x => x.id === mId || x.machine_per_branch_id === mId);
                      return !(m && (m.type === "Smartpay Ecommerce" || m.name === "Smartpay Ecommerce"));
                    });
                  }) && (
                      <span style={{ fontSize: 11, color: '#b0b8c4' }}>Sin máquinas ecommerce asignadas</span>
                    )}
                </div>
              </div>
            </div>


          </div>
          <button onClick={onClose} className="ec-btn-close">✕</button>
        </div>

        {form.description && (<>
          <div className="ec-detail-section">
            <label className="ec-detail-label">Descripción</label>

          </div>
          <div
            className="ec-detail-branch-name"
            style={{
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              padding: '12px 16px',
              fontWeight: 600,
              fontSize: 16,
              color: '#1a1a2e',
              borderBottom: '1px solid #e5e7eb',
              background: '#f3f4f6',
              borderRadius: '12px',
            }}
            onClick={() => (setEditing(true), setTypeEdit("event"))}
          >
            <span style={{ flex: 1 }}><i class="uil uil-edit-alt text-center"> </i>  - {form.description}</span>
            <span
              style={{
                marginLeft: 8,
                fontSize: 20,
                display: 'flex',
                alignItems: 'center',
                transition: 'color 0.2s',
                color: '#b0b8c4',
              }}
            >

            </span>
          </div>
        </>
        )}


        <div className="ec-form-group">
          <label className="ec-label">Sucursales del evento</label>
          <div
            className="ec-detail-branch-name"
            style={{
              cursor: 'pointer',
              display: 'flex',
              padding: '12px 16px',
              fontWeight: 600,
              fontSize: 16,
              color: '#1a1a2e',
              borderBottom: '1px solid #e5e7eb',
              background: '#f3f4f6',
              borderRadius: '12px',
            }}
            onClick={() => (setEditing(true), setTypeEdit("branch"))}
          >
            <span style={{ flex: 1 }}><i class="uil uil-edit-alt text-center"> </i>  - Editar sucursales</span>
            <span
              style={{
                marginLeft: 8,
                fontSize: 20,
                display: 'flex',
                alignItems: 'center',
                transition: 'color 0.2s',
                color: '#b0b8c4',
              }}
            >
            </span>
          </div>


          {/* Acordeón para sucursales */}
          {form.branches && form.branches.map((bId) => {
            const branch = branchOfficesData.find((b) => b.id === bId);
            if (!branch) return null;

            const handleToggle = async () => {
              if (openBranch === bId) {
                setOpenBranch(null);
              } else {
                setOpenBranch(bId);
                let token = localStorage.getItem('x-access-token');
                try {
                  const machines = await MachinesFetchAPI.getMachinesByBranchOffice(bId, token);
                  // Filtrar solo las máquinas que están en event.branchMachines[bId]
                  const allowedIds = event.branchMachines && event.branchMachines[bId] ? event.branchMachines[bId] : [];
                  const filteredMachines = machines.data.data.filter((m) => allowedIds.includes(m.machine_per_branch_id));
                  setMachinesByBranch((prev) => ({ ...prev, [bId]: filteredMachines }));
                  setMachinesAllByBranch((prev) => ({ ...prev, [bId]: machines.data.data }));
                } catch (err) {
                  setMachinesByBranch((prev) => ({ ...prev, [bId]: [] }));
                  setMachinesAllByBranch((prev) => ({ ...prev, [bId]: [] }));
                }
              }
            };

            return (
              <div
                key={bId}
                className={`ec-detail-branch${openBranch === bId ? ' ec-detail-branch--active' : ''}`}
                style={{
                  border: '1px solid #e5e7eb',
                  borderRadius: 12,
                  marginBottom: 12,
                  boxShadow: openBranch === bId ? '0 2px 8px #94a3b820' : 'none',
                  background: openBranch === bId ? branch.color + '08' : '#fff',
                  transition: 'box-shadow 0.2s, background 0.2s',
                }}
              >
                <div
                  className="ec-detail-branch-name"
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    padding: '12px 16px',
                    fontWeight: 600,
                    fontSize: 16,
                    color: branch.color,
                    borderBottom: openBranch === bId ? `1px solid ${branch.color}30` : 'none',
                    background: openBranch === bId ? branch.color + '10' : 'transparent',
                    borderRadius: openBranch === bId ? '12px 12px 0 0' : '12px',
                  }}
                  onClick={handleToggle}
                >
                  <span style={{ marginRight: 12 }}>{branch.icon}</span>
                  <span style={{ flex: 1 }}>{branch.name}</span>
                  <span
                    style={{
                      marginLeft: 8,
                      fontSize: 20,
                      display: 'flex',
                      alignItems: 'center',
                      transition: 'color 0.2s',
                      color: openBranch === bId ? branch.color : '#b0b8c4',
                    }}
                  >
                    {openBranch === bId ? (
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 8L10 12L14 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    ) : (
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 6L12 10L8 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    )}
                  </span>
                </div>
                {openBranch === bId && (
                  <div
                    className="ec-detail-branch-machines"
                    style={{
                      padding: '12px 16px',
                      background: '#f9fafb',
                      borderRadius: '0 0 12px 12px',
                      borderTop: `1px solid ${branch.color}10`,
                      display: 'flex',
                      gap: 8,
                      flexWrap: 'wrap',
                      flexDirection: 'column',
                    }}
                  >
                    {machinesByBranch[bId] && machinesByBranch[bId].length === 0 && (
                      <span style={{ fontSize: 11, color: '#b0b8c4' }}>Sin máquinas asignadas</span>
                    )}
                    {machinesByBranch[bId] && machinesByBranch[bId].map((m) => (
                      <div
                        key={m.machine_per_branch_id}
                        className="ec-machine-badge--detail"
                        style={{
                          background: branch.color + '14',
                          color: branch.color,
                          border: `1px solid ${branch.color}30`,
                          padding: '6px 14px',
                          borderRadius: 8,
                          fontWeight: 500,
                          fontSize: 15,
                          display: 'flex',
                          alignItems: 'center',
                          gap: 8,
                        }}
                      >
                        {m.machine_name}

                      </div>
                    ))}
                    {/* Acordeón interno para agregar máquinas */}
                    <div
                      className={`ec-detail-branch${openMachineAccordion === bId ? ' ec-detail-branch--active' : ''}`}
                      style={{
                        border: '1px solid #e5e7eb',
                        borderRadius: 12,
                        marginTop: 16,
                        boxShadow: openMachineAccordion === bId ? '0 2px 8px #94a3b820' : 'none',
                        background: openMachineAccordion === bId ? '#f3f4f6' : '#fff',
                        transition: 'box-shadow 0.2s, background 0.2s',
                      }}
                    >

                    </div>
                  </div>
                )}
              </div>
            );
          })}

        </div>

        {form.notes && (
          <div className="ec-detail-section">
            <label className="ec-detail-label">Notas</label>
            <p className="ec-detail-text">{form.notes}</p>
          </div>
        )}

        <div className="ec-detail-actions">
          <button onClick={() => (navigate("/rules/event/" + event.id))} className="ec-btn-primary" style={{ flex: 1 }}>Reglas del evento</button>
          {form.state === 1 ? (
            <button className="ec-btn-primary" style={{ flex: 1, border: '1px solid #22c55e', color: '#22c55e', background: '#fff' }} onClick={() => updateEvent(0)}>Activo</button>
          ) : (
            <button className="ec-btn-primary" style={{ flex: 1, border: '1px solid #b0b8c4', color: '#b0b8c4', background: '#fff' }} onClick={() => updateEvent(1)}>Inactivo</button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div>

      <RenderIf isTrue={typeEdit === "branch"}>
        <div className="ec-edit-header">
          <h2 className="ec-edit-title">Editar sucursal</h2>
          <button onClick={() => setEditing(false)} className="ec-btn-close">✕</button>
        </div>

        <div className="ec-form-group">
          <label className="ec-label">Sucursales del evento</label>
          <div
            className={`ec-detail-branch${openBranch === 'add' ? ' ec-detail-branch--active' : ''}`}
            style={{
              border: '1px solid #e5e7eb',
              borderRadius: 12,
              marginBottom: 12,
              boxShadow: openBranch === 'add' ? '0 2px 8px #94a3b820' : 'none',
              background: openBranch === 'add' ? '#f3f4f6' : '#fff',
              transition: 'box-shadow 0.2s, background 0.2s',
            }}
          >
            <div
              className="ec-detail-branch-name"
              style={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                padding: '12px 16px',
                fontWeight: 600,
                fontSize: 16,
                color: '#1a1a2e',
                borderBottom: openBranch === 'add' ? '1px solid #e5e7eb' : 'none',
                background: openBranch === 'add' ? '#f3f4f6' : 'transparent',
                borderRadius: openBranch === 'add' ? '12px 12px 0 0' : '12px',
              }}
              onClick={() => setOpenBranch(openBranch === 'add' ? null : 'add')}
            >
              <span style={{ flex: 1 }}><i class="uil uil-plus-circle"></i> Agregar nueva sucursal</span>
              <span
                style={{
                  marginLeft: 8,
                  fontSize: 20,
                  display: 'flex',
                  alignItems: 'center',
                  transition: 'color 0.2s',
                  color: openBranch === 'add' ? '#1a1a2e' : '#b0b8c4',
                }}
              >
                {openBranch === 'add' ? (
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 8L10 12L14 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                ) : (
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 6L12 10L8 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                )}
              </span>
            </div>
            {openBranch === 'add' && (
              <div
                className="ec-detail-branch-machines"
                style={{
                  padding: '12px 16px',
                  background: '#f9fafb',
                  borderRadius: '0 0 12px 12px',
                  borderTop: '1px solid #e5e7eb',
                  display: 'flex',
                  gap: 8,
                  flexWrap: 'wrap',
                  flexDirection: 'column',
                }}
              >
                {branchOfficesData
                  .filter((b) => !(form.branches || []).includes(b.id))
                  .map((b) => {
                    const sel = newBranches.includes(b.id);
                    return (
                      <button
                        key={b.id}
                        onClick={() => {
                          const updated = sel ? newBranches.filter((x) => x !== b.id) : [...newBranches, b.id];
                          setNewBranches(updated);
                        }}
                        className="ec-branch-option"
                        style={sel ? { borderColor: b.color, background: b.color + '06', marginBottom: 8 } : { marginBottom: 8 }}
                      >
                        <div className={`ec-branch-icon${sel ? '' : ' ec-branch-icon--inactive'}`} style={sel ? { background: b.color + '18' } : {}}>
                          {b.icon}
                        </div>
                        <div>
                          <div className={`ec-branch-name${sel ? '' : ' ec-branch-name--inactive'}`} style={sel ? { color: b.color } : {}}>
                            {b.name}
                          </div>
                          <div className="ec-branch-address">{b.address}</div>
                        </div>
                        {sel && <span className="ec-branch-check">✓</span>}
                      </button>
                    );
                  })}
                <button
                  className="ec-btn-primary"
                  style={{ marginTop: 12, alignSelf: 'flex-end' }}
                  disabled={newBranches.length === 0}
                  onClick={() => asignBranchToEvent()}
                >Agregar sucursales seleccionadas</button>
              </div>
            )}
          </div>
          {/* Acordeón para sucursales */}
          {form.branches && form.branches.map((bId) => {
            const branch = branchOfficesData.find((b) => b.id === bId);
            if (!branch) return null;

            const handleToggle = async () => {
              if (openBranch === bId) {
                setOpenBranch(null);
              } else {
                setOpenBranch(bId);
                let token = localStorage.getItem('x-access-token');
                try {
                  const machines = await MachinesFetchAPI.getMachinesByBranchOffice(bId, token);
                  // Filtrar solo las máquinas que están en event.branchMachines[bId]
                  const allowedIds = event.branchMachines && event.branchMachines[bId] ? event.branchMachines[bId] : [];
                  const filteredMachines = machines.data.data.filter((m) => allowedIds.includes(m.machine_per_branch_id));
                  setMachinesByBranch((prev) => ({ ...prev, [bId]: filteredMachines }));
                  setMachinesAllByBranch((prev) => ({ ...prev, [bId]: machines.data.data }));
                } catch (err) {
                  setMachinesByBranch((prev) => ({ ...prev, [bId]: [] }));
                  setMachinesAllByBranch((prev) => ({ ...prev, [bId]: [] }));
                }
              }
            };

            return (
              <div
                key={bId}
                className={`ec-detail-branch${openBranch === bId ? ' ec-detail-branch--active' : ''}`}
                style={{
                  border: '1px solid #e5e7eb',
                  borderRadius: 12,
                  marginBottom: 12,
                  boxShadow: openBranch === bId ? '0 2px 8px #94a3b820' : 'none',
                  background: openBranch === bId ? branch.color + '08' : '#fff',
                  transition: 'box-shadow 0.2s, background 0.2s',
                }}
              >
                <div
                  className="ec-detail-branch-name"
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    padding: '12px 16px',
                    fontWeight: 600,
                    fontSize: 16,
                    color: branch.color,
                    borderBottom: openBranch === bId ? `1px solid ${branch.color}30` : 'none',
                    background: openBranch === bId ? branch.color + '10' : 'transparent',
                    borderRadius: openBranch === bId ? '12px 12px 0 0' : '12px',
                  }}
                  onClick={handleToggle}
                >
                  <span style={{ marginRight: 12 }}>{branch.icon}</span>
                  <span style={{ flex: 1 }}>{branch.name}</span>
                  <span
                    style={{
                      marginLeft: 8,
                      fontSize: 20,
                      display: 'flex',
                      alignItems: 'center',
                      transition: 'color 0.2s',
                      color: openBranch === bId ? branch.color : '#b0b8c4',
                    }}
                  >
                    {openBranch === bId ? (
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 8L10 12L14 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    ) : (
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 6L12 10L8 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    )}
                  </span>
                </div>
                {openBranch === bId && (
                  <div
                    className="ec-detail-branch-machines"
                    style={{
                      padding: '12px 16px',
                      background: '#f9fafb',
                      borderRadius: '0 0 12px 12px',
                      borderTop: `1px solid ${branch.color}10`,
                      display: 'flex',
                      gap: 8,
                      flexWrap: 'wrap',
                      flexDirection: 'column',
                    }}
                  >
                    {machinesByBranch[bId] && machinesByBranch[bId].length === 0 && (
                      <span style={{ fontSize: 11, color: '#b0b8c4' }}>Sin máquinas asignadas</span>
                    )}
                    {machinesByBranch[bId] && machinesByBranch[bId].map((m) => (
                      <div
                        key={m.machine_per_branch_id}
                        className="ec-machine-badge--detail"
                        style={{
                          background: branch.color + '14',
                          color: branch.color,
                          border: `1px solid ${branch.color}30`,
                          padding: '6px 14px',
                          borderRadius: 8,
                          fontWeight: 500,
                          fontSize: 15,
                          display: 'flex',
                          alignItems: 'center',
                          gap: 8,
                        }}
                      >
                        {m.machine_name}
                        <button
                          style={{
                            marginLeft: 8,
                            background: 'transparent',
                            border: 'none',
                            color: branch.color,
                            fontSize: 18,
                            cursor: 'pointer',
                          }}
                          title="Eliminar máquina"
                          onClick={async () => {
                            let token = localStorage.getItem('x-access-token');
                            try {
                              await EventsFetchAPI.deleteMachineFromEvent({ event_date_id: event.date_id, machines: [m.machine_per_branch_id] }, token);
                              // Actualizar el detalle
                              const detail = await getEventDetaills(event, true);
                              setSelectedEvent(detail);
                              setForm({ ...detail, branchMachines: { ...(detail.branchMachines || {}) } });
                              // Refrescar machinesByBranch
                              const allowedIds = detail.branchMachines && detail.branchMachines[bId] ? detail.branchMachines[bId] : [];
                              const assignedMachines = machinesAllByBranch[bId]?.filter((mach) => allowedIds.includes(mach.machine_per_branch_id)) || [];
                              setMachinesByBranch((prev) => ({ ...prev, [bId]: assignedMachines }));
                            } catch (err) {
                              AlertSmall({ message: 'Error al eliminar máquina', icon: 'error' });
                            }
                          }}
                        ><i class="uil uil-trash-alt"></i></button>
                      </div>
                    ))}
                    {/* Acordeón interno para agregar máquinas */}
                    <div
                      className={`ec-detail-branch${openMachineAccordion === bId ? ' ec-detail-branch--active' : ''}`}
                      style={{
                        border: '1px solid #e5e7eb',
                        borderRadius: 12,
                        marginTop: 16,
                        boxShadow: openMachineAccordion === bId ? '0 2px 8px #94a3b820' : 'none',
                        background: openMachineAccordion === bId ? '#f3f4f6' : '#fff',
                        transition: 'box-shadow 0.2s, background 0.2s',
                      }}
                    >
                      <div
                        className="ec-detail-branch-name"
                        style={{
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          padding: '12px 16px',
                          fontWeight: 600,
                          fontSize: 16,
                          color: '#1a1a2e',
                          borderBottom: openMachineAccordion === bId ? '1px solid #e5e7eb' : 'none',
                          background: openMachineAccordion === bId ? '#f3f4f6' : 'transparent',
                          borderRadius: openMachineAccordion === bId ? '12px 12px 0 0' : '12px',
                        }}
                        onClick={() => setOpenMachineAccordion(openMachineAccordion === bId ? null : bId)}
                      >
                        <span style={{ flex: 1 }}><i className="uil uil-plus-circle"></i> Agregar máquinas</span>
                        <span
                          style={{
                            marginLeft: 8,
                            fontSize: 20,
                            display: 'flex',
                            alignItems: 'center',
                            transition: 'color 0.2s',
                            color: openMachineAccordion === bId ? '#1a1a2e' : '#b0b8c4',
                          }}
                        >
                          {openMachineAccordion === bId ? (
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M6 8L10 12L14 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          ) : (
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M8 6L12 10L8 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          )}
                        </span>
                      </div>
                      {openMachineAccordion === bId && (
                        <div
                          className="ec-detail-branch-machines"
                          style={{
                            padding: '12px 16px',
                            background: '#f9fafb',
                            borderRadius: '0 0 12px 12px',
                            borderTop: '1px solid #e5e7eb',
                            display: 'flex',
                            gap: 8,
                            flexWrap: 'wrap',
                            flexDirection: 'column',
                          }}
                        >
                          {/* Mostrar máquinas disponibles para agregar */}
                          {machinesAllByBranch[bId] && machinesAllByBranch[bId]
                            .filter((m) => !machinesByBranch[bId]?.some((assigned) => assigned.machine_per_branch_id === m.machine_per_branch_id))
                            .map((m) => (
                              (m.name === "Smart pos" || m.name === "Smart Pay") && (
                                <button
                                  key={m.machine_per_branch_id}
                                  className="ec-machine-badge--add"
                                  style={{
                                    background: '#2d3748', // gris oscuro
                                    color: '#f3f4f6', // texto claro
                                    border: '1px solid #4a5568',
                                    padding: '6px 14px',
                                    borderRadius: 8,
                                    fontWeight: 500,
                                    fontSize: 15,
                                    marginBottom: 8,
                                  }}
                                  onClick={async () => {
                                    let token = localStorage.getItem('x-access-token');
                                    try {
                                      let data = {
                                        "event_date_id": event.date_id,
                                        "machines": [m.machine_per_branch_id]
                                      }
                                      const res = await EventsFetchAPI.assignMachinestoEvent(data, token)
                                      // Actualizar el detalle
                                      const detail = await getEventDetaills(event, true);
                                      setSelectedEvent(detail);
                                      setForm({ ...detail, branchMachines: { ...(detail.branchMachines || {}) } });
                                      // Refrescar machinesByBranch para mostrar la máquina recién asignada
                                      const allowedIds = detail.branchMachines && detail.branchMachines[bId] ? detail.branchMachines[bId] : [];
                                      const assignedMachines = machinesAllByBranch[bId]?.filter((mach) => allowedIds.includes(mach.machine_per_branch_id)) || [];
                                      setMachinesByBranch((prev) => ({ ...prev, [bId]: assignedMachines }));
                                    } catch (err) {
                                      AlertSmall({ message: 'Error al agregar máquina', icon: 'error' });
                                    }
                                  }}
                                >+ {m.machine_name}</button>)
                            ))}
                        </div>
                      )}
                    </div>
                    <button
                      className="ec-btn-danger"
                      style={{ marginTop: 12, alignSelf: 'flex-end' }}
                      onClick={async () => deleteBarnchFromEvent(bId)}
                    >Remover sucursal</button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
        <div className="ec-edit-actions">
          <button onClick={() => setEditing(false)} className="ec-btn-secondary" style={{ flex: 1 }}>Cancelar</button>
        </div>
      </RenderIf>

      <RenderIf isTrue={typeEdit === "event"}>
        <div className="ec-edit-header">
          <h2 className="ec-edit-title">Editar evento</h2>
          <button onClick={() => setEditing(false)} className="ec-btn-close">✕</button>
        </div>

        <div className="ec-form-group">
          <label className="ec-label">Nombre del evento</label>
          <input value={nameEdit} onChange={(e) => setNameEdit(e.target.value)} className="ec-input" />
        </div>

        <div className="ec-form-group">
          <label className="ec-label">Descripción</label>
          <textarea
            value={descriptionEdit}
            onChange={(e) => setDescriptionEdit(e.target.value)}
            className="ec-textarea"
            style={{ minHeight: 60 }}
          />
        </div>

        <div className="ec-edit-actions">
          <button onClick={() => setEditing(false)} className="ec-btn-secondary" style={{ flex: 1 }}>Cancelar</button>
          <button onClick={() => updateEvent()} className="ec-btn-primary" style={{ flex: 1 }}>Guardar cambios</button>
        </div>
      </RenderIf>




      <RenderIf isTrue={typeEdit === "date"}>
        <div className="ec-edit-header">
          <h2 className="ec-edit-title">Editar fecha: {formatDate(form.start)} → {formatDate(form.end)} </h2>
          <button onClick={() => setEditing(false)} className="ec-btn-close">✕</button>
        </div>

        <div className="ec-form-group">
          <label className="ec-label">Rango de fechas</label>
          <div className="ec-range-wrap">
            <RangeCalendar
              start={newDate.start}
              end={newDate.end}
              onRangeChange={(s, e) => setNewDate({ start: s, end: e })}
              hovered={hovered}
              setHovered={setHovered}
              pickerMonth={pm}
              pickerYear={py}
              setPickerMonth={setPm}
              setPickerYear={setPy}
              compact={compact}
            />
          </div>
        </div>

        <div className="ec-edit-actions">
          <button onClick={() => setEditing(false)} className="ec-btn-secondary" style={{ flex: 1 }}>Cancelar</button>
          <button onClick={() => updateDateEvent()} className="ec-btn-primary" style={{ flex: 1 }}>Actualizar fecha</button>
        </div>
      </RenderIf>


      {/*<div className="ec-form-group">
          <label className="ec-label">Notas adicionales</label>
          <textarea
            value={form.notes || ""}
            onChange={(e) => setForm({ ...form, notes: e.target.value })}
            className="ec-textarea"
            style={{ minHeight: 50 }}
          />
        </div>*/}





    </div>
  );
}
